import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { motion } from "framer-motion";
import logo from "@/assets/logo.png";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const { error: authError } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (authError) {
      setError("Credenziali non valide");
      setLoading(false);
      return;
    }

    // Check if user is admin
    const { data: roles } = await supabase
      .from("user_roles")
      .select("role")
      .eq("role", "admin")
      .maybeSingle();

    if (!roles) {
      await supabase.auth.signOut();
      setError("Accesso non autorizzato");
      setLoading(false);
      return;
    }

    navigate("/admin");
  };

  const inputClass =
    "w-full bg-transparent border border-foreground/20 rounded-sm px-4 py-3 text-foreground font-body text-sm placeholder:text-foreground/40 focus:outline-none focus:border-accent transition-colors duration-300";

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-sm"
      >
        <div className="text-center mb-10">
          <img src={logo} alt="Logo" className="h-10 mx-auto mb-6" />
          <h1 className="font-heading text-2xl font-bold text-foreground uppercase tracking-wider">
            Admin
          </h1>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputClass}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputClass}
            required
          />

          {error && (
            <p className="text-sm text-red-400 font-body">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="cta-button w-full justify-center hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-300 disabled:opacity-50"
          >
            {loading ? "Accesso..." : "Accedi"}
          </button>
        </form>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
